import { _ as __rest, a as __assign } from '../../tslib.es6-21effb23.js';
import { c as classNames } from '../../index-29eed6c4.js';
import React__default, { useMemo } from 'react';
import { s as skeletonStyles } from '../../skeleton.module-4f527a2f.js';
import { d as defaultTheme } from '../../ThemeProvider-030aad7d.js';

var styles = {"container":"IndicatorLabel_container_d01332be","size-extra-small":"IndicatorLabel_size-extra-small_d01332be","size-small":"IndicatorLabel_size-small_d01332be","size-medium":"IndicatorLabel_size-medium_d01332be","size-large":"IndicatorLabel_size-large_d01332be","withLeftIcon":"IndicatorLabel_withLeftIcon_d01332be","skeleton":"IndicatorLabel_skeleton_d01332be","label":"IndicatorLabel_label_d01332be","dot":"IndicatorLabel_dot_d01332be"};

var IndicatorLabel = React__default.forwardRef(function IndicatorLabel(props, ref) {
    var _a, _b;
    var className = props.className, label = props.label, _c = props.size, size = _c === void 0 ? "small" : _c, _d = props.color, colorProp = _d === void 0 ? "action" : _d, isSkeleton = props.isSkeleton, dotColor = props.dotColor, leftIcon = props.leftIcon, otherProps = __rest(props, ["className", "label", "size", "color", "isSkeleton", "dotColor", "leftIcon"]);
    var color = useMemo(function () {
        if ((!Object.keys(defaultTheme).includes(colorProp.replace("-dark", ""))) &&
            colorProp.replace("-dark", "") !== "interface" &&
            colorProp != "white") {
            // In case a non-default color is passed in, use action
            return "action";
        }
        return colorProp;
    }, [colorProp]);
    var getColor = function (color) {
        if (color === "white") {
            return "var(--color-white)";
        }
        if (color === "interface-dark") {
            return "var(--color-ui-interface-mid)";
        }
        if (color.endsWith("-dark")) {
            return "var(--color-ui-".concat(color.replace("-dark", ""), ")");
        }
        return "var(--color-ui-".concat(color, "-10)");
    };
    var getBorderColor = function (color) {
        if (color === "white") {
            return "var(--color-ui-interface-20)";
        }
        if (color.endsWith("-dark")) {
            return "var(--color-ui-".concat(color, ")");
        }
        return "var(--color-ui-".concat(color, "-20)");
    };
    var getLabelColor = function (color) {
        if (color === "white") {
            return "var(--color-ui-interface-dark)";
        }
        if (color === "warning-dark") {
            return "var(--color-black)";
        }
        if (color.endsWith("-dark")) {
            return "var(--color-white)";
        }
        return "var(--color-ui-".concat(color, "-dark)");
    };
    var labelStyle = useMemo(function () {
        if (isSkeleton) {
            return undefined;
        }
        return {
            "--indicator-color": getColor(color),
            "--indicator-border-color": getBorderColor(color),
            "--indicator-label-color": getLabelColor(color),
        };
    }, [isSkeleton, color]);
    return (React__default.createElement("div", __assign({ ref: ref, "aria-busy": isSkeleton, className: classNames(styles.container, styles["size-".concat(size)], (_a = {},
            _a[skeletonStyles.skeleton] = isSkeleton,
            _a[styles.skeleton] = isSkeleton,
            _a[styles.withLeftIcon] = leftIcon,
            _a), className), style: labelStyle, "data-testid": "indicator-label" }, otherProps),
        leftIcon,
        React__default.createElement("span", { className: styles.label, "data-testid": "indicator-label-text" }, label),
        dotColor && (React__default.createElement("span", { className: classNames(styles.dot, (_b = {},
                _b[styles.skeleton] = isSkeleton,
                _b)), "data-testid": "indicator-label-dot", style: { backgroundColor: isSkeleton ? undefined : dotColor } }))));
});

export { IndicatorLabel };
